<template>
  <div>
    <p class="crm-kicker">Configuration</p>
    <h1 class="crm-title">Champs perso</h1>
    <p class="crm-hint">Configurables — texte, oui/non, liste, nombre</p>
    <div class="crm-card">
      <div class="crm-field"><label class="crm-label">Libellé</label><input class="crm-input" v-model="form.label" /></div>
      <div class="crm-field">
        <label class="crm-label">Type</label>
        <select class="crm-select" v-model="form.field_type">
          <option value="texte">Texte</option>
          <option value="oui_non">Oui/Non</option>
          <option value="liste">Liste</option>
          <option value="nombre">Nombre</option>
        </select>
      </div>
      <div class="crm-field">
        <label class="crm-label">Où</label>
        <select class="crm-select" v-model="form.where_scope">
          <option value="nouveau">Nouveau</option>
          <option value="connu">Connu</option>
          <option value="les_deux">Les deux</option>
        </select>
      </div>
      <button type="button" class="crm-choice" :class="{ on: form.required }" @click="form.required = !form.required">
        {{ form.required ? 'Obligatoire · Oui' : 'Obligatoire · Non' }}
      </button>
      <button type="button" class="crm-btn crm-btn-primary crm-btn-lg" style="margin-top:12px" @click="save">Ajouter</button>
    </div>
    <div v-for="f in fields" :key="f.id" class="crm-list-row">
      <div style="flex:1;min-width:0">
        <div class="crm-row-title">{{ f.label }}</div>
        <div class="crm-row-meta">{{ f.field_type }} · {{ f.where_scope }} {{ f.required ? '· obligatoire' : '' }}</div>
      </div>
      <button type="button" class="crm-chip" :class="{ on: f.enabled }" @click="toggle(f)">{{ f.enabled ? 'On' : 'Off' }}</button>
      <button type="button" class="crm-chip" @click="remove(f)">Suppr.</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CrmSalonChamps',
  data() {
    return {
      fields: [],
      form: { label: '', field_type: 'texte', where_scope: 'les_deux', required: false }
    }
  },
  mounted() { this.load() },
  methods: {
    async load() {
      const { data } = await this.$apollo.query({
        client: 'AUTH',
        query: require('src/graphql/auth/crmSalon/crmSalonCustomFields.gql'),
        fetchPolicy: 'network-only'
      })
      this.fields = data.crmSalonCustomFields || []
    },
    async save() {
      if (!this.form.label) return
      await this.$apollo.mutate({
        client: 'AUTH',
        mutation: require('src/graphql/auth/crmSalon/crmSalonUpsertCustomField.gql'),
        variables: { ...this.form, enabled: true }
      })
      this.form.label = ''
      this.load()
    },
    async toggle(f) {
      await this.$apollo.mutate({
        client: 'AUTH',
        mutation: require('src/graphql/auth/crmSalon/crmSalonUpsertCustomField.gql'),
        variables: { id: f.id, enabled: !f.enabled, label: f.label }
      })
      this.load()
    },
    async remove(f) {
      await this.$apollo.mutate({
        client: 'AUTH',
        mutation: require('src/graphql/auth/crmSalon/crmSalonDeleteCustomField.gql'),
        variables: { id: f.id }
      })
      this.load()
    }
  }
}
</script>
